// 📄 pages/SAP-BTP/components/AvisosAnalisis.tsx
// Avisos del análisis de un .zip (subir iFlow y nueva versión): valores fijos
// del .iflw (hay que confirmar para guardar) y parámetros con valor (por
// defecto se guardan vacíos). Los valores llegan YA enmascarados del backend.
import React from 'react';
import { AlertTriangle, CheckCircle2, ShieldAlert } from 'lucide-react';
import { AnalisisIflow } from '../../../services/iflowService.ts';

interface AvisosAnalisisProps {
  analisis: AnalisisIflow;
  confirmaFijos: boolean;
  onConfirmaFijos: (v: boolean) => void;
  vaciarParametros: boolean;
  onVaciarParametros: (v: boolean) => void;
}

export default function AvisosAnalisis({ analisis, confirmaFijos, onConfirmaFijos, vaciarParametros, onVaciarParametros }: AvisosAnalisisProps) {
  const hayFijos = analisis.valoresFijos.length > 0;
  const hayParametros = analisis.parametrosConValor.length > 0;

  if (!hayFijos && !hayParametros) {
    return (
      <div className="flex items-center gap-2 text-emerald-300 text-xs">
        <CheckCircle2 className="w-4 h-4" /> No se encontraron direcciones fijas ni parámetros con valores.
      </div>
    );
  }

  return (
    <>
      {hayFijos && (
        <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4 space-y-3">
          <div className="flex items-start gap-2 text-amber-300 text-sm">
            <ShieldAlert className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <div>
              <p className="font-medium">Este iFlow tiene direcciones o alias fijos</p>
              <p className="text-xs text-amber-200/80 mt-1">
                Quedan dentro del .zip (solo los podrán descargar quienes tengan acceso a esta organización). En OneHub no se guardan ni se muestran completos.
                Lo recomendable es externalizarlos como parámetros en Integration Suite.
              </p>
            </div>
          </div>
          <ul className="text-xs font-mono text-amber-100/90 space-y-1 pl-6">
            {analisis.valoresFijos.map((v, i) => (
              <li key={i}>{v.adaptador} · {v.campo}: {v.valor}</li>
            ))}
          </ul>
          <label className="flex items-center gap-2 text-xs text-white pl-6 cursor-pointer">
            <input type="checkbox" checked={confirmaFijos} onChange={(e) => onConfirmaFijos(e.target.checked)} className="accent-cyan-500" />
            Entiendo, guardar el iFlow de todas formas
          </label>
        </div>
      )}

      {hayParametros && (
        <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 space-y-3">
          <div className="flex items-start gap-2 text-blue-300 text-sm">
            <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <div>
              <p className="font-medium">Parámetros externalizados con valores</p>
              <p className="text-xs text-blue-200/80 mt-1">Pueden ser datos del cliente. Sin valores, el iFlow se importa igual y se configuran en el tenant.</p>
            </div>
          </div>
          <ul className="text-xs font-mono text-blue-100/90 space-y-1 pl-6">
            {analisis.parametrosConValor.map((p) => <li key={p.nombre}>{p.nombre} = {p.valor}</li>)}
          </ul>
          <label className="flex items-center gap-2 text-xs text-white pl-6 cursor-pointer">
            <input type="checkbox" checked={vaciarParametros} onChange={(e) => onVaciarParametros(e.target.checked)} className="accent-cyan-500" />
            Guardar sin los valores (recomendado)
          </label>
        </div>
      )}
    </>
  );
}
